import { APP } from 'src/Configs/App'
import { SearchedTrack } from 'src/Pages/Artist/CreateCampaignPage/Components/TrackSearch'
import { rtkApi } from 'src/Services/rtkApi'

type Image = {
  url?: string
  height?: number
  width?: number
}

type SearchPlaylistResponse = {
  id: string
  name: string
  ownerName: string
  description: string
  images: Image[]
  ownerUrl: string
  followers: number
  url: string
}

const searchPlaylistApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    searchPlaylist: build.query<SearchedTrack, string>({
      query: (playlistId) => ({
        url: `${APP.TIKTOK_SERVER}/public/spotify-playlists/${playlistId}`,
      }),
      transformResponse: (response: SearchPlaylistResponse): SearchedTrack => ({
        id: response.id,
        name: response.name,
        artistName: response.ownerName,
        trackCoverUrl: response.images[0].url || '',
        resourceSpotifyUrl: response.url,
        ownerSpotifyUrl: response.ownerUrl,
        previewUrl: '',
        trackDuration: '', // Duration is not provided in the response
      }),
    }),
  }),
})

export const { useLazySearchPlaylistQuery } = searchPlaylistApi
